import { floorKeep } from '@lhb/func';

export function getTotalSalesAmountPredict(
  category1SalesAmountPredict?: number | null,
  category2SalesAmountPredict?: number | null,
) {
  const category1SalesAmount = category1SalesAmountPredict ?? 0;
  const category2SalesAmount = category2SalesAmountPredict ?? 0;
  return floorKeep(category1SalesAmount, category2SalesAmount, 2);
}
